import { t } from 'bv-i18n';

export const getScoreboardHeaders = (coupon, sport, treeType, firstScoreboard) => {
  if (treeType === 'upcoming') {
    return {
      className: '',
      labels: [],
    };
  }

  // Darts
  if (sport.id === 965300) {
    return {
      className: 'inply-coupon-header-set-scores',
      labels: firstScoreboard && firstScoreboard.bos > 1 ? [
        t('javascript.darts.periods.sets_abrv'),
        t('javascript.darts.periods.legs_abrv'),
        t('javascript.darts.periods.points_abrv'),
      ] : [
        t('javascript.darts.periods.legs_abrv'),
        t('javascript.darts.periods.points_abrv'),
      ],
    };
  }
  // Tennis and such
  if (coupon === 'template_d') {
    return {
      className: 'inply-coupon-header-set-scores',
      labels: [
        t('javascript.tennis.periods.sets_abrv'),
        t('javascript.tennis.periods.games_abrv'),
        t('javascript.tennis.periods.points_abrv'),
      ],
    };
  }
  return null;
};

export default {};
